import React from 'react';
import Router from './components/Router/Router';
import GlobalTooltip from './common/GlobalTooltip';
import './App.css';

function App() {
  return (
    <>
      <Router />
      <GlobalTooltip />
    </>
  );
}

export default App;